import styled from 'styled-components';

export const Line = styled.hr`
  background: linear-gradient(to right, #00ffaa, #3079ff);
  font-size: 10px;
  height: 4px;
  border: 0;
  border-radius: 5px;
`;
